// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardBubble {
  position: absolute;
  top: -1rem;
  left: 1rem;
  padding: 0.5rem 1rem;
  background-color: var(--bs-light);
  border-radius: var(--bs-border-radius-pill);
  border: var(--bs-border-width) solid var(--bs-border-color);
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/CardBubble/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,iCAAA;EACA,2CAAA;EACA,2DAAA;AACF","sourcesContent":[".CardBubble {\n  position: absolute;\n  top: -1rem;\n  left: 1rem;\n  padding: 0.5rem 1rem;\n  background-color: var(--bs-light);\n  border-radius: var(--bs-border-radius-pill);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
